import { render, staticRenderFns } from "./homepage.vue?vue&type=template&id=4dce78bc&scoped=true&"
import script from "./homepage.vue?vue&type=script&lang=js&"
export * from "./homepage.vue?vue&type=script&lang=js&"
import style0 from "./homepage.vue?vue&type=style&index=0&id=4dce78bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dce78bc",
  null
  
)

component.options.__file = "homepage.vue"
export default component.exports